'use client';

import { SearchIcon } from '@/components/icons/search-icon';
import { Field, FieldLabel } from '@/components/ui/field';
import { InputGroup, InputGroupAddon, InputGroupButton, InputGroupInput } from '@/components/ui/input-group';
import { zodResolver } from '@hookform/resolvers/zod';
import { useRouter } from 'next/navigation';
import { Controller, useForm } from 'react-hook-form';
import { z } from 'zod';
import articlesSearchStyles from './articles-search.module.scss';

type ArticlesSearchProps = {
  hasResults?: boolean;
  initialQuery: string;
};

export const ArticlesSearch = ({ hasResults, initialQuery }: ArticlesSearchProps): React.JSX.Element => {
  const router = useRouter();

  const formSchema = z.object({
    search: z.string(),
  });

  const form = useForm<z.infer<typeof formSchema>>({
    defaultValues: {
      search: initialQuery,
    },
    resolver: zodResolver(formSchema),
  });

  const onSubmit = (values: z.infer<typeof formSchema>): void => {
    const trimmed = values.search.trim();
    router.push(`?query=${encodeURIComponent(trimmed)}&page=1`);
  };

  return (
    <form className={articlesSearchStyles.search}
      onSubmit={form.handleSubmit(onSubmit)}
    >
      <Controller control={form.control}
        name="search"
        render={({ field, fieldState }) =>
          <Field>
            {hasResults &&
              <FieldLabel className="font-bold"
                dataTest="label-search-articles-results"
                error={!!fieldState.error}
                htmlFor="search"
                id="label-search-articles-results"
              >
                Search Movie News
              </FieldLabel>
            }
            <InputGroup>
              <InputGroupInput {...field}
                aria-invalid={fieldState.invalid}
                id="search"
              />
              <InputGroupAddon align="inline-end">
                <InputGroupButton aria-label={hasResults ? undefined : 'Search Movie News'}
                  aria-labelledby={hasResults ? 'label-search-articles-results' : undefined}
                  data-test="button-articles-search"
                  type="submit"
                  variant="ghost"
                >
                  <SearchIcon aria-hidden="true"
                    className="icon icon-primary"
                  />
                </InputGroupButton>
              </InputGroupAddon>
            </InputGroup>
          </Field>
        }
      />
    </form>
  );
};
